"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface RightOfUseAssetsSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Right-of-Use Assets";

export default function RightOfUseAssetsSubstantive({ onBack, setActiveSection }: RightOfUseAssetsSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
